import React from 'react';
import PropTypes from 'prop-types';
import CoreMap from '@bd/bdui-coremap';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import HomeCardMapPopUp from './HomeCardMapPopUp';
import { colors } from '../styles';

const styles = css`
  width: 100%;
  height: 100%;
`;

const homeMap = css`
  position: relative;
  height: 300px;
  width: 100%;
  z-index: 0;
  @media (min-width: 992px) {
    height: 600px;
    width: auto;
    flex-grow: 1;
  }
  .leaflet-popup {
    margin-bottom: 54px;
  }
  .leaflet-popup-content-wrapper {
    padding: 0;
    border-radius: 0;
  }
  .leaflet-popup-content {
    margin: 0;
  }
  .leaflet-container a.leaflet-popup-close-button {
    color: ${colors.white};
    z-index: 2;
  }
  .leaflet-popup-content-wrapper, .leaflet-popup-tip {
    background: ${colors.brand1};
  }
`;

function HomeMap({ activeMapPin, homes }) {
  return (
    <div className={styles}>
      <CoreMap
        animate
        useFlyTo
        boundsOptions={{ animate: true, duration: 0.5 }}
        activePin={activeMapPin}
        pin={{
          iconUrl: '/images/icon-map-pin-brand.svg',
          iconSize: [37, 53],
          iconAnchor: [18, 53],
        }}
        className={homeMap}
        markers={homes}
        popup={({ marker: home }) => (
          <HomeCardMapPopUp home={home} />
        )}
      />
    </div>
  );
}

HomeMap.propTypes = {
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeMapPin: PropTypes.string,
};

HomeMap.defaultProps = {
  activeMapPin: undefined,
  sort: { title: 'Name', field: 'name' },
};

export default withData(
  {
    activeMapPin: true,
    homes: true,
  },
  {
    required: {
      homes: true,
    },
  },
)(HomeMap);



// WEBPACK FOOTER //
// ./src/components/HomeMap.js